import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import {  useEffect, useMemo, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { BsTelephone } from "react-icons/bs";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetUser } from "redux/userSlice";
import { EMAIL_REGEX, LANDLINE_REGEX, PHONE_REGEX } from "../regexPatterns";
import orgJson from "components/jsonData/orgnization.json";
import CustomSelect from "components/CustomSelect";
import InputFormControl from "../component/inputFormControl";
import RadioField from "../component/radioField";

const  AccountUser=({isOpen,onClose,isEdit,handleUser,editData,userIds,allUsers})=> {
    const dispatch = useDispatch();
    const userList = useSelector((state) => state.userData);
    const [errors,setErrors] = useState({})
    const [userIdOptions,setUserIdOptions] = useState([])
    const [selectedUserId,setSelectedUSerId] = useState("")
    const [user,setUser] = useState("")
    const [users,setUsers] = useState([])
    const [formData,setFormData] = useState({
      name:"",
      mail:"",
      ph:"",
      mob:"",
      isA:false
    })


    useEffect(()=>{
      dispatch(fetchAsyncGetUser())
    }, []);

    useMemo(async()=>{
      if(userIds && userIds?.length){
        const allOptions = await clientProjectOptions('useId','useId',userIds);
        setUserIdOptions(allOptions)
        if(editData?.useId){
          const uobj = allOptions.find((opt)=>opt?.value === editData?.useId);
          setSelectedUSerId(uobj)
        }
      }
    },[userIds])

    useEffect(()=>{
      if(editData && editData?._id){
        setFormData({
          name:editData?.name,
          mail:editData?.mail,
          ph:editData?.ph,
          mob:editData?.mob,
          isA:editData?.isA
        })
      }
    },[editData])
    useEffect(()=>{
      if(userList && userList.length){
        const allUsedUserIds = allUsers && allUsers?.length ? allUsers.map(user => user?.user) : [];
        const allUserOptions =  clientProjectOptions('name','_id',userList) 
        const filteredOptions = allUserOptions.filter(opt => !allUsedUserIds.includes(opt.value));

        setUsers(filteredOptions)
        if(editData && editData?.user){
          const selectedUser = allUserOptions.find((opt)=>opt.value === editData?.user);
          setUser(selectedUser)
        }
      }
    },[userList])

    const validate = () => {
      const newErrors = {};
  
      if (!user?.value) newErrors.user = 'User Is Required!';
      if (!selectedUserId?.value) newErrors.userId = 'User Id Is Required!';

      if (formData.mail && !EMAIL_REGEX.test(formData.mail)) newErrors.mail = orgJson.error.email;
      if (formData.ph && !LANDLINE_REGEX.test(formData.ph)) newErrors.ph = orgJson.error.invalidPhone;
      if (formData.mob && !PHONE_REGEX.test(formData.mob)) newErrors.phone = orgJson.error.phone;
        
     
      setErrors(newErrors);
  
      
      return Object.keys(newErrors).length === 0;
    };
  
    useMemo(()=>{
      if(user && user?.value){
        const id = user?.value;
        const obj = userList.find((item)=>item?._id === id);
        setFormData({
          ...formData,
          name:obj.name,
          mail:obj.email
        })
      }
    },[user])
    
    const toCamelCase = (value) => {
      return value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    };
    
    const handleChange = (e) => {
      const { name, value } = e.target;
      let formattedValue = value;
  
      if (name === "mail") {
        formattedValue = value.toLowerCase();
      } else {
        formattedValue = toCamelCase(value);
      }
  
      if (name === "mob") {
        if (!formattedValue || PHONE_REGEX.test(formattedValue)) {
          setErrors((prev) => ({ ...prev, mob: "" }));
        } else {
          setErrors((prev) => ({
            ...prev,
            phone: orgJson.error.phone,
          }));
        }
      }
      if (name === "ph") {
        if (!formattedValue || LANDLINE_REGEX.test(formattedValue)) {
          setErrors((prev) => ({ ...prev, ph: "" }));
        } else {
          setErrors((prev) => ({ ...prev, ph: orgJson.error.invalidPhone }));
        }
      }
      if (name === "mail") {
        if (!formattedValue || EMAIL_REGEX.test(formattedValue)) {
          setErrors((prev) => ({ ...prev, mail: "" }));
        } else {
          setErrors((prev) => ({ ...prev, mail: orgJson.error.email }));
        }
      }
        setFormData((prev) => ({
          ...prev,
          [name]: formattedValue,
        }));
    };


    const handleAdd = (e)=>{
      e.preventDefault();
      if (validate()) {
        const id = editData?._id || null
        handleUser({...formData,user:user?.value,useId:selectedUserId?.value},id)
        onClose();
      }
    }

    
    return (
      <>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          isCentered
          className="account-user-modal"
        >
          <ModalOverlay />
          <ModalContent maxH="fit-content" className="add-account-user-modal">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header">
                {isEdit ? "Edit" : "Add"} User Details
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody className="mt-5">
              <Row>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>
                      <span className="required">User*</span>
                    </Form.Label>
                    <CustomSelect
                      options={users}
                      placeHolder={<div>Select User...</div>}
                      onChange={(newValue) => setUser(newValue)}
                      isSearchable
                      defaultValue={user}
                      isDisabled={isEdit}
                    />
                  </Box>
                    <p className="form_error"> {errors[`user`]}</p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>
                      <span className="required">User ID*</span>
                    </Form.Label>
                    <CustomSelect
                      options={userIdOptions}
                      placeHolder={<div>Select User ID...</div>}
                      onChange={(newValue) => setSelectedUSerId(newValue)}
                      isSearchable
                      defaultValue={selectedUserId}
                    />
                  </Box>
                    <p className="form_error"> {errors[`userId`]}</p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Name</Form.Label>
                    <InputFormControl
                      placeholder="Name"
                      isDisabled={true}
                      name="name"
                      value={formData?.name}
                      handleChange={(e) => handleChange(e)}
                    />
                  </Box>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>
                      <span className="required">Email*</span>
                    </Form.Label>
                    <InputFormControl
                      placeholder="Email"
                      name="mail"
                      value={formData?.mail}
                      isDisabled={true}
                      isInvalid={!!errors.mail}
                      handleChange={(e) => handleChange(e)}
                    />
                  </Box>
                  <p className="form_error"> {errors[`mail`]}</p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Phone</Form.Label>
                    <InputFormControl
                      name="ph"
                      placeholder="Work Phone"
                      handleChange={(e) => handleChange(e)}
                      value={formData.ph || ""}
                      isInvalid={!!errors.ph}
                      groupText1={
                        <InputGroup.Text id="basic-addon1">
                          <BsTelephone />
                        </InputGroup.Text>
                      }
                    />
                  </Box>
                  <p className="form_error"> {errors[`ph`]}</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Box display="flex" className="input-box mt-3">
                    <Form.Label>Mobile</Form.Label>                      
                      <InputFormControl
                        name="mob"
                        placeholder="Mobile"
                        value={formData.mob || ""}
                        handleChange={(e) => handleChange(e)}
                        isInvalid={!!errors.mob}
                        groupText1={
                          <InputGroup.Text id="basic-addon1">
                            <MdOutlinePhoneAndroid />
                          </InputGroup.Text>
                        }
                      />
                  </Box>
                </Col>
                <p className="form_error"> {errors[`mob`]}</p>
              </Row>
              <Row>
                <Col>
                  <Box display="flex" mt={3}>
                    <Form.Label>Status</Form.Label>
                    <Box className="d-flex" ml={20}>
                      <RadioField
                        name="isA"
                        label="Active"
                        isChecked={formData?.isA}
                        customClass="mx-4"
                        handleChange={(e) =>
                          setFormData({
                            ...formData,
                            isA: true,
                          })
                        }
                      />
                      <RadioField
                        name="isA"
                        label="Not Active"
                        isChecked={!formData?.isA}
                        handleChange={(e) =>
                          setFormData({
                            ...formData,
                            isA: false,
                          })
                        }
                      />
                    </Box>
                  </Box>
                </Col>
              </Row>
            </ModalBody>

            <ModalFooter>
              <Button
                className="btn save-btn"
                onClick={(e) => handleAdd(e)}
                mr={3}
              >
                {isEdit ? "Edit" : "Add"}
              </Button>
              <Button onClick={onClose} className="btn">
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }

  export default AccountUser;